export default __webpack_public_path__ + "static/media/26.25d95ffe.png";